module.exports = __webpack_public_path__ + "img/google-ads.31dddd12.jpg";